import axios from "axios";

export interface OptimizationRuleSyncedEvent {
  id: number;
  "optimization-rule-id": number;
  name: string;
  timestamp: string;
  "user-data": {
    em?: string;
    fbc?: string;
    fbp?: string;
    client_ip_address?: string;
    client_user_agent?: string;
  };
  "custom-data": {
    value?: number;
  };
}

export const getOptimizationRuleSyncedEvents = async (
  workspace: string,
  optimizationRuleId: number,
): Promise<OptimizationRuleSyncedEvent[]> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspace}/optimization-rules/${optimizationRuleId}/events`,
    )
  ).data;
};
